import { defineField, defineType } from 'sanity'

export default defineType({
  name: 'fitmentCategory',
  title: 'Fitment Category',
  type: 'object',
  groups: [
    {
      name: 'summary',
      title: 'Summary',
      default: true,
    },
    {
      name: 'fitments',
      title: 'Fitments',
    },
  ],
  fields: [
    defineField({
      name: 'name',
      title: 'Name',
      type: 'string',
      validation: (Rule) => Rule.required(),
      group: 'summary',
    }),
    defineField({
      name: 'fitmentType',
      title: 'Fitment type',
      type: 'reference',
      to: [
        {
          type: 'fitment',
        },
      ],
      options: {
        disableNew: true,
      },
      group: 'summary',
    }),
    defineField({
      name: 'description',
      title: 'Description',
      type: 'array',
      of: [{ type: 'block' }],
      group: 'summary',
    }),
    defineField({
      name: 'fitments',
      title: 'Fitments',
      type: 'array',
      of: [{ type: 'fitmentListing' }],
      group: 'fitments',
    }),
  ],
})
